import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitizeString'
})
export class SanitizeStringPipe implements PipeTransform {

  transform(value: string): string {
    if (value && value !== '') {
      let cleanString = value.replace(/&quot;/g, '"');
      cleanString = cleanString.replace(/&#039;/g, '\'');
      cleanString = cleanString.replace(/&amp;/g, '&');
      return cleanString;
    }
    return value;
  }

}
